const mediaWidths = {
  medium: 750,
  large: 990,
  widescreen: 1400,
};

/*

  Hover Toggle Child
  
  Add class .htc-hover to the element to be hovered
  Add class . htc-toggle to the element to be toggled

*/
class HoverToggleChild extends HTMLElement {
  constructor() {
    super();

    this.hovers = this.querySelectorAll(".htc-hover");

    this.hovers.forEach((hoveredElement) => {
      const toggle = hoveredElement.querySelector(".htc-toggle");

      hoveredElement.addEventListener("mouseenter", () => {
        toggle.style.display = "initial";
      });

      toggle.addEventListener("mouseleave", () => {
        toggle.style.display = "none";
      });
    });
  }
}

customElements.define("hover-toggle-child", HoverToggleChild);

/*

  Creates a responsive image wrapper.
  Using the width and height it will calculate the required padding %
  <image-wrapper>
    <img src.. height="required" width="required"
  </image-wrapper>

*/
class ImageWrapper extends HTMLElement {
  constructor() {
    super();

    this.image = this.querySelector("img");

    const imgWidth = parseInt(this.image.getAttribute("width"));
    const imgHeight = parseInt(this.image.getAttribute("height"));
    const imgRatio = (imgHeight / imgWidth) * 100;

    this.style.paddingTop = `${imgRatio}%`;
  }
}

customElements.define("image-wrapper", ImageWrapper);

/*
  Pulls the dom elements from each /section/mega-nav-$x and appends
  it to their parent.
  Click and hover events here.
*/
class NavMegaChildren extends HTMLElement {
  constructor() {
    super();

    const navOfChildren = this.querySelector(".shbnm-level-2");
    const numberOfChildren = navOfChildren.dataset.childamount;
    const myParentString = navOfChildren.dataset.belongsto;
    const myParent = document.querySelector(
      `[data-parenthandle=${myParentString}]`
    );
    const myParentLink = myParent.querySelector(".shbnm-level-1_link");

    this.headerSolid = document.querySelector("[data-header-solid]");

    if (parseInt(navOfChildren.dataset.active) === 0) return;

    myParentLink.after(this);
    myParent.classList.add("has-children-" + numberOfChildren);

    if (window.innerWidth > mediaWidths.large) {
      this.hoverParent(myParentLink, navOfChildren);
      this.mouseLeaveChildren(navOfChildren);
    }

    if (window.innerWidth < mediaWidths.large) {
      this.clickParent(myParentLink, navOfChildren);
    }
  }

  // Functions
  showChildren(parentChildren) {
    this.hideAllChildren();
    parentChildren.style.display = "initial";
  }

  hideChildren(parentChildren) {
    parentChildren.style.display = "none";
  }

  hideAllChildren() {
    document.querySelectorAll(".shbnm-level-2").forEach((i) => {
      i.style.display = "none";
    });
    document.querySelector(".ftnm-children").style.display = "none";
  }

  doHeaderSolid(megaMenu) {
    const Header = new HeaderMain();
    Header.doLogoColor("dark");
    //If header is sticky, do not remove fix position
    if (!document.body.classList.contains("header-is-fixed")) {
      document
        .querySelector(".section-header-bottom")
        .classList.add("remove-fix-position");
    }
    document.body.classList.add("header-is-fixed");
    this.setHeaderHeight(megaMenu);
  }

  removeHeaderSolid(megaMenu) {
    const Header = new HeaderMain();
    if (this.headerSolid == null) {
      this.doLogoColor("default");
    }
    document.body.classList.remove("header-is-fixed");
    this.setHeaderHeight(megaMenu);
  }

  setHeaderHeight(megaMenu) {
    const headerHeight = megaMenu.getBoundingClientRect().top;
    // console.log(headerHeight);
    megaMenu.style.maxHeight = `calc(100vh - ${headerHeight}px)`;
  }

  // Events
  mouseLeaveChildren(parentChildren) {
    parentChildren.addEventListener("mouseleave", (e) => {
      const bodyScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.hideChildren(e.currentTarget);
      document
        .querySelector(".section-header-bottom")
        .classList.remove("remove-fix-position");
      if (bodyScrollTop <= 199) {
        this.removeHeaderSolid(parentChildren);
      }
    });
  }

  hoverParent(hoverParent, parentChildren) {
    hoverParent.addEventListener("mouseover", () => {
      this.showChildren(parentChildren);
      this.doHeaderSolid(parentChildren);
    });
  }

  clickParent(clickedParent, parentChildren) {
    clickedParent.addEventListener("click", (e) => {
      e.preventDefault();
      this.showChildren(parentChildren);
    });
  }
}

customElements.define("nav-mega-children", NavMegaChildren);

/*

  > Mobile triggers
  > Mobile naughtyChild data is generated pulling data from the top nav
  > Onscroll Fixed header

*/
class HeaderMain extends HTMLElement {
  constructor() {
    super();

    this.toggler = this.querySelector(".shb-mob-toggle");
    this.header = this.querySelector(".section-header");
    this.naughtyParent = this.querySelector(".from-top-nav-mob");
    this.headerSolid = document.querySelector("[data-header-solid]");

    this.doMobileMenu();
    this.naughtyChildrenInject();
    this.naughtyParentClick();

    window.addEventListener(
      "scroll",
      function () {
        throttle(this.changeDesign(), 200);
      }.bind(this)
    );
    this.doHeaderSolid();
  }

  changeDesign() {
    const bodyScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    /*

      if header solid detected

      add header-is-solid

    */

    if (bodyScrollTop >= 200) {
      document.body.classList.add("header-is-fixed");
      document.body.classList.add("header-has-scrolled");
      this.doLogoColor("dark");
    }

    if (bodyScrollTop <= 199) {
      document.body.classList.remove("header-is-fixed");
      document.body.classList.remove("header-has-scrolled");
      if (this.headerSolid == null) {
        this.doLogoColor("default");
      }
    }
  }

  doLogoColor(version = "dark") {
    const logoMob = document.getElementById("logo-header-mob");
    const logoMobOriginal = logoMob.dataset.originalsrc;
    const logoMobDarkSrc = logoMob.dataset.darkmob;

    const logo = document.getElementById("logo-header");
    const logoOriginal = logo.dataset.originalsrc;
    const logoDarkSrc = logo.dataset.dark;

    if (version === "dark") {
      logoMob.srcset = "";
      logoMob.src = logoMobDarkSrc;
      logo.srcset = "";
      logo.src = logoDarkSrc;
      return;
    }

    // default
    if (version === "default") {
      logoMob.src = logoMobOriginal;
      logo.src = logoOriginal;
    }

    return;
  }

  enableMobileMenu(enable = true) {
    const hamburger = this.toggler.querySelector(".icon-hamburger");
    const close = this.toggler.querySelector(".icon-close");

    if (enable) {
      hamburger.style.display = "none";
      close.style.display = "initial";
      this.toggler.dataset.togglestatus = 1;
      this.header.classList.add("header-mob-active");
      document.body.style.overflow = "hidden";
      return;
    }
    hamburger.style.display = "initial";
    close.style.display = "none";
    this.toggler.dataset.togglestatus = 0;
    this.header.classList.remove("header-mob-active");
    document.body.style.overflow = "unset";
  }

  doHeaderSolid() {
    if (
      this.headerSolid != null ||
      document.querySelector(".shopify-challenge__container") != null
    ) {
      this.doLogoColor("dark");
      document.body.classList.add("header-is-solid");
    }
  }

  doMobileMenu() {
    if (this.toggler === null) return;

    this.toggler.addEventListener("click", (e) => {
      const toggleStatus = parseInt(e.currentTarget.dataset.togglestatus);

      toggleStatus === 0
        ? this.enableMobileMenu()
        : this.enableMobileMenu(false);
    });
  }

  naughtyChildrenInject() {
    const topNavLinks = document.querySelectorAll(".shtn-level-1");
    const childrenHTML = [...topNavLinks]
      .map((child) => {
        const data = {
          bg: child.dataset.bg,
          title: child.querySelector("a").innerHTML.trim(),
          url: child.querySelector("a").href,
          buttonName: child.dataset.buttonname,
        };

        return this.naughtyChildrenHTML(data);
      })
      .join("");

    const familyHTML = `<ul
    class="ftnm-children-ul has-children-${topNavLinks.length}">
      ${childrenHTML}
      </ul>
    `;
    if (this.naughtyParent === null) return false;
    this.naughtyParent.querySelector(".ftnm-children").innerHTML = familyHTML;
  }

  naughtyChildrenHTML(data) {
    return `
    <li class="ftnm-child" style="background-image:url(${data.bg})">
      <a href="${data.url}">
        <div class="ftnmc-content">
          <div class="ftnmc-content-inner">
            <h4 class="h3">${data.title}</h4>
            <span>${data.buttonName}</span>
          </div>
        </div>
      </a>
    </li>`;
  }

  naughtyParentClick() {
    if (this.naughtyParent === null) return false;
    this.naughtyParent
      .querySelector(".ftnm-link")
      .addEventListener("click", (e) => {
        e.preventDefault();
        const active = parseInt(e.currentTarget.dataset.active);

        if (active === 0) {
          document.querySelectorAll(".shbnm-level-2").forEach((i) => {
            i.style.display = "none";
          });
          document.querySelector(".ftnm-children").style.display = "initial";
          e.currentTarget.dataset.active = 1;
          return;
        }

        document.querySelector(".ftnm-children").style.display = "none";
        e.currentTarget.dataset.active = 0;
      });
  }
}

customElements.define("header-main", HeaderMain);

class WebsiteSelector extends HoverToggleChild {}
customElements.define("website-selector", WebsiteSelector);

class VideoMove extends HTMLElement {
  constructor() {
    super();

    this.playButton = this.querySelector(".svm-play-icon");
    this.playButton.addEventListener("click", () => {
      this.doVideo();
    });
  }

  doVideo() {
    const videoSection = this.querySelector("[data-video-move-status]");
    const currentStatus = parseInt(videoSection.dataset.videoMoveStatus);

    if (currentStatus == 0) {
      videoSection.dataset.videoMoveStatus = 1;
      videoSection.classList.remove("svm-video-disabled");
      videoSection.classList.add("svm-video-enabled");
    }

    if (currentStatus == 1) {
      videoSection.dataset.videoMoveStatus = 0;
      videoSection.classList.remove("svm-video-enabled");
      videoSection.classList.add("svm-video-disabled");
    }
  }
}

customElements.define("video-move", VideoMove);

// Youtube global scope functions
function youtubeInit() {
  const videoIframes = document.querySelectorAll("[data-ytvideo]");

  if (videoIframes.length > 0) {
    var players = new Array();
    const tag = document.createElement("script");
    const firstScriptTag = document.getElementsByTagName("script")[0];
    const playersData = [...videoIframes].map((videoIframe) => {
      return {
        id: videoIframe.id,
        videoId: videoIframe.dataset.videoid,
        jsclass: videoIframe.dataset.jsclass,
      };
    });

    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = function () {
      if (typeof playersData === "undefined") return;
      for (var i = 0; i < playersData.length; i++) {
        var curplayer = createPlayer(playersData[i]);
        players[i] = curplayer;
      }
    };

    function createPlayer(playerInfo) {
      const defaultPlayer = {
        videoId: playerInfo.videoId,
        playerVars: {
          showinfo: 0,
          rel: 0,
        },
      };

      const ytplayer =
        playerInfo.jsclass != undefined
          ? videoClass(playerInfo.jsclass, playerInfo.videoId)
          : defaultPlayer;

      return new YT.Player(playerInfo.id, ytplayer);
    }

    function videoClass(className, videoid) {
      const classMap = {
        HeroDim: new HeroDimYT(),
        VideoMove: new VideoMoveYT(),
        VideoGrid: new VideoGridYT(),
        VideoCute: new CuteYT(),
      };

      return classMap[className].ytPlayerOptions(videoid);
    }
  }
}
youtubeInit();

/*
  Toggle classes on hover
*/
class BannerSides extends HTMLElement {
  constructor() {
    super();

    this.hoverDisabled = this.querySelector("[data-hoverdisabled]");
    if (this.hoverDisabled != null) return;

    this.section = this.querySelector(".section-banner-sides");
    this.triggerHover = this.querySelector(".sbs-trigger-hover");

    this.triggerHover.addEventListener("mouseenter", () => {
      this.section.classList.add("sbs-hover");
    });

    this.triggerHover.addEventListener("mouseleave", () => {
      this.section.classList.remove("sbs-hover");
    });
  }
}
customElements.define("banner-sides", BannerSides);

class ProductCompare extends HTMLElement {
  constructor() {
    super();

    this.section = this.querySelector(".section-product-compare");
    this.sectionInitialHeight = this.section.offsetHeight;
    this.imageIntros = this.querySelectorAll(
      "[data-js-image-intro] [data-image-intro]"
    );
    this.compareItems = this.querySelectorAll(
      "[data-js-item] [data-compare-item]"
    );

    window.addEventListener(
      "scroll",
      function () {
        throttle(this.toggleClassName(), 200);
      }.bind(this)
    );

    this.cellContentMinHeight();
    this.compareSelector();
    if (window.innerWidth >= 1400) {
      this.dynamicContainer();
    }
    window.addEventListener(
      "resize",
      function (event) {
        var newWidth = window.innerWidth;
        if (newWidth >= 1400) {
          this.dynamicContainer();
        } else {
          this.clearDynamicContainer();
        }
      }.bind(this)
    );
  }

  clearDynamicContainer() {
    const container = document.querySelector(".container-dynamic");
    container.style.marginRight = "auto";
  }

  dynamicContainer() {
    const containerSmall = document.querySelector(".container-s");
    const container = document.querySelector(".container-dynamic");
    const rightSpace = window.getComputedStyle(containerSmall).marginRight;
    container.style.marginRight = rightSpace;
  }

  cellMinHeight() {
    const compareItems = this.querySelectorAll(".compare-item");
    const cellHeights = [...compareItems].map((item) => ({
      highlights: item.querySelector("[data-cell-highlights]").offsetHeight,
      variants: item.querySelector("[data-cell-variants]").offsetHeight,
      features: item.querySelector("[data-cell-features]").offsetHeight,
      specs: item.querySelector("[data-cell-specs]").offsetHeight,
    }));

    const tallestHighlight = this.highestNumber(
      cellHeights[0].highlights,
      cellHeights[1].highlights
    );
    const tallestVariant = this.highestNumber(
      cellHeights[0].variants,
      cellHeights[1].variants
    );
    const tallestFeature = this.highestNumber(
      cellHeights[0].features,
      cellHeights[1].features
    );
    const tallestSpec = this.highestNumber(
      cellHeights[0].specs,
      cellHeights[1].specs
    );

    // Apply tallest height for cells
    [...compareItems].forEach((item) => {
      item.querySelector("[data-cell-highlights]").style.minHeight =
        tallestHighlight + "px";
      item.querySelector("[data-cell-variants]").style.minHeight =
        tallestVariant + "px";
      item.querySelector("[data-cell-features]").style.minHeight =
        tallestFeature + "px";
      item.querySelector("[data-cell-specs]").style.minHeight =
        tallestSpec + "px";
    });
  }

  // compares tallest cell and applies the tallest cell to all cells in col1 and col2
  cellContentMinHeight() {
    const compareItems = this.querySelectorAll(".compare-item");
    const compareColumn1 = compareItems[0].querySelectorAll(
      "[data-cell-content]"
    );
    const compareColumn2 = compareItems[1].querySelectorAll(
      "[data-cell-content]"
    );
    const col1CellHeights = [...compareColumn1].map(
      (cellContent) => cellContent.offsetHeight
    );
    const col2CellHeights = [...compareColumn2].map(
      (cellContent) => cellContent.offsetHeight
    );

    const tallestCell = col1CellHeights.map((cellHeight, i) => {
      return this.highestNumber(cellHeight, col2CellHeights[i]);
    });

    compareItems.forEach((col) => {
      const cells = col.querySelectorAll("[data-cell-content]");
      cells.forEach(
        (cell, i) => (cell.style.minHeight = tallestCell[i] + "px")
      );
    });
  }

  highestNumber(number1, number2) {
    if (number1 > number2) {
      return number1;
    }
    return number2;
  }

  /*
    Toggle class names depending on the sections position
  */
  toggleClassName() {
    const bodyScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const sectionTop = this.section.offsetTop - 300;
    const sectionHeight = this.sectionInitialHeight;
    const sectionBottom = sectionTop + (sectionHeight - 300);

    if (bodyScrollTop < sectionTop - 1) {
      this.section.classList.remove("spc-is-fixed");
    }

    if (bodyScrollTop >= sectionTop && bodyScrollTop <= sectionBottom) {
      this.section.classList.add("spc-is-fixed");
    }

    if (bodyScrollTop > sectionBottom) {
      this.section.classList.remove("spc-is-fixed");
    }
  }

  compareSelector() {
    const selectors = this.querySelectorAll("[data-compare-selector]");
    selectors.forEach((selector) => {
      const selectorList = selector.querySelectorAll("li");
      const selectorOutput = selector.querySelector(".compare-selected span");
      const selectorButton = selector.querySelector(".compare-selected");
      const selectorDropdown = selector.querySelector("ul");

      const hideDropdown = () => {
        selectorDropdown.style.display = "none";
        selector.setAttribute("data-dropdown", 0);
        selectorButton.classList.remove("button-active");
      };

      const showDropdown = () => {
        selectorDropdown.style.display = "initial";
        selector.setAttribute("data-dropdown", 1);
        selectorButton.classList.add("button-active");
      };

      selectorButton.addEventListener("click", () => {
        const dropdownStatus = selector.dataset.dropdown;

        if (dropdownStatus === "0") {
          showDropdown();
        }

        if (dropdownStatus === "1") {
          hideDropdown();
        }
      });

      selectorList.forEach((li) => {
        li.addEventListener("click", () => {
          removeActiveSelector(selectorList);
          li.classList.add("this-active");
          selectorOutput.innerHTML = li.innerHTML;
          this.changeCompareContent(
            li.dataset.blockId,
            selector.dataset.compareSelector
          );
          this.changeCompareTables(
            li.dataset.productHandle,
            selector.dataset.compareSelector
          );
          hideDropdown();
        });
      });
    });

    const removeActiveSelector = (list) => {
      list.forEach((li) => {
        li.classList.remove("this-active");
      });
    };
  }

  /*  
    uses a hidden dom tables as reference to update the displayed table on the dom.
  */
  changeCompareTables(handle, pos) {
    const displayColumn1_tds = this.querySelectorAll(
      `[data-display] table td[data-td-pos="1"]`
    );
    const displayColumn2_tds = this.querySelectorAll(
      `[data-display] table td[data-td-pos="2"]`
    );
    const refByHandle_tds = this.querySelectorAll(
      `[data-reference] table td[data-handle="${handle}"]`
    );
    const tds = pos === "1" ? displayColumn1_tds : displayColumn2_tds;

    [...tds].forEach((td, i) => {
      const requestedTd = refByHandle_tds[i]
        .querySelector("[data-content]")
        .cloneNode(true);
      td.innerHTML = "";
      td.append(requestedTd);
    });
  }

  changeCompareContent(blockId, outputPosition) {
    const outputArea_imageIntro = this.querySelector(
      `.spc-product-compare-box-image-intro .spcb-item[data-position="${outputPosition}"]`
    );
    const outputArea_item = this.querySelector(
      `.spc-product-compare-box-item .spcb-item[data-position="${outputPosition}"]`
    );

    outputArea_imageIntro.innerHTML = "";
    outputArea_imageIntro.append(this.getImageIntro(blockId));

    outputArea_item.innerHTML = "";
    outputArea_item.append(this.getCompareItem(blockId));
  }

  getImageIntro(blockId) {
    const imageIntro = [...this.imageIntros].filter(
      (imageIntro) => imageIntro.dataset.blockId == blockId
    );
    if (imageIntro[0] == null) return null;

    const clonedImageIntro = imageIntro[0]
      .querySelector(".spcb-image")
      .cloneNode(true);
    return clonedImageIntro;
  }

  getCompareItem(blockId) {
    const compareItem = [...this.compareItems].filter(
      (item) => item.dataset.blockId == blockId
    );
    if (compareItem[0] == null) return null;

    const clonedCompareItem = compareItem[0]
      .querySelector(".spcb-content")
      .cloneNode(true);
    return clonedCompareItem;
  }
}
customElements.define("product-compare", ProductCompare);

class HeroDimYT {
  ytPlayerOptions(videoid) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopInfo.shopUrl,
      },
      events: {
        onReady: this.ytOnReady,
        onStateChange: this.ytOnPlayerStateChange,
      },
    };
  }
  ytOnReady(e) {
    const videoId = e.target.getVideoData().video_id;
    const heroDimSectionId = document
      .querySelector(`[data-videoid="${videoId}"]`)
      .getAttribute("data-sectionid");
    const heroDimSection = document.getElementById(heroDimSectionId);
    const heroImages = heroDimSection.querySelectorAll(".shd-image");

    e.target.playVideo();
    e.target.mute();

    heroImages.forEach((heroImage) => {
      heroImage.style.opacity = 0;
    });
  }
  ytOnPlayerStateChange(e) {
    if (e.data === YT.PlayerState.ENDED) {
      e.target.playVideo();
    }
  }
}

class VideoMoveYT {
  ytPlayerOptions(videoid) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopInfo.shopUrl,
      },
      events: {
        onReady: this.ytOnReady,
      },
    };
  }
  ytOnReady(e) {
    const videoId = e.target.getVideoData().video_id;
    const playerSectionId = document
      .querySelector(`[data-videoid="${videoId}"]`)
      .getAttribute("data-sectionid");
    const playerSection = document.getElementById(playerSectionId);
    if (playerSection != null) {
      const playButton = playerSection.querySelector(".svm-play-icon");
      playButton.addEventListener("click", () => {
        e.target.playVideo();
      });
    }
  }
}

class VideoGridYT {
  ytPlayerOptions(videoid) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopInfo.shopUrl,
      },
      events: {
        onReady: this.ytOnReady,
      },
    };
  }
  ytOnReady(e) {
    const videoId = e.target.getVideoData().video_id;
    const playerParentId = document
      .querySelector(`[data-videoid="${videoId}"]`)
      .getAttribute("data-video-parent-id");
    const playerParent = document.getElementById(playerParentId);
    if (playerParent != null) {
      const playButton = playerParent.querySelector(".svgb-play");
      const img = playerParent.querySelector(".svgb-video-img");
      playButton.addEventListener("click", () => {
        img.style.display = "none";
        playButton.style.display = "none";
        e.target.playVideo();
      });
    }
  }
}

class CuteYT {
  ytPlayerOptions(videoid) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopInfo.shopUrl,
      },
      events: {
        onReady: this.ytOnReady,
        onStateChange: this.ytOnPlayerStateChange,
      },
    };
  }
  ytOnReady(e) {
    const videoId = e.target.getVideoData().video_id;
    const cuteSectionId = document
      .querySelector(`[data-videoid="${videoId}"]`)
      .getAttribute("data-sectionid");
    const cuteSection = document.getElementById(cuteSectionId);
    const cuteImages = cuteSection.querySelectorAll(".sc-img");
    e.target.playVideo();
    e.target.mute();

    cuteImages.forEach((cuteImage) => {
      cuteImage.style.opacity = 0;
    });
  }
  ytOnPlayerStateChange(e) {
    if (e.data === YT.PlayerState.ENDED) {
      e.target.playVideo();
    }
  }
}

function throttle(func, wait = 100) {
  let timer = null;
  return function (...args) {
    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(this, args);
        timer = null;
      }, wait);
    }
  };
}

class HopeCard extends HTMLElement {
  constructor() {
    super();
    this.toggleImage();
  }

  toggleImage() {
    const button = this.querySelector(".snippet-button-primary");
    const img = this.querySelector(".hcf-image img");

    if (!img.dataset.imageHover) return;

    const originalSrcSet = img.srcset;

    button.addEventListener("mouseover", () => {
      this.imageTransition(img, img.dataset.imageHover);
    });

    button.addEventListener("mouseleave", () => {
      this.imageTransition(img, originalSrcSet);
    });
  }

  imageTransition(img, src) {
    img.style.opacity = 0;
    setTimeout(() => {
      img.srcset = src;
      img.style.opacity = 1;
    }, 200);
  }
}

customElements.define("hope-card", HopeCard);

function autoScrollElementTop(element, offset = 150) {
  if (element != null) {
    const position = element.getBoundingClientRect();
    window.scroll({
      top: position.top + window.scrollY - offset,
      left: 0,
      behavior: "smooth",
    });
  }
}

autoScrollElementTop(document.querySelector("[data-scroll-top]"));

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.headerSearchIcon = document.getElementById("header-search-icon");
    this.searchClose = this.querySelector(".sf-close");
    this.searchDrawer = this.querySelector(".snippet-search-drawer");
    if (!this.headerSearchIcon) return;

    this.init();
  }

  init() {
    this.searchClose.addEventListener("click", () => {
      this.closeDrawer(this.searchDrawer);
    });

    this.headerSearchIcon.addEventListener("click", (e) => {
      e.preventDefault();
      this.openDrawer(this.searchDrawer);
    });
  }

  openDrawer(element) {
    element.classList.remove("ssd-close");
    element.classList.add("ssd-open");
  }

  closeDrawer(element) {
    element.classList.remove("ssd-open");
    element.classList.add("ssd-close");
  }
}

customElements.define("search-drawer", SearchDrawer);

class CountryPopup extends HTMLElement {
  constructor() {
    super();

    this.localStorageName = "disableCountryPopup";
    this.init();
  }

  init() {
    this.disableSeenPopup();

    if (this.isDisabled() === false) {
      setTimeout(() => {
        this.openPopup();
        this.onClickOut();
        this.onClickCurrentCountry();
      }, 3000);
    }

    this.querySelector(".icon-close").addEventListener("click", () => {
      this.closePopup();
      this.disablePopup();
    });
  }

  disableSeenPopup() {
    const searchParams = new URLSearchParams(window.location.search);
    const popupSeen =
      searchParams.get("countryPopupSeen") === "1" ? true : false;

    if (popupSeen) {
      this.disablePopup();
    }
  }

  isDisabled() {
    const disableCountryPopup = localStorage.getItem(this.localStorageName);
    return disableCountryPopup ? true : false;
  }

  disablePopup() {
    localStorage.setItem(this.localStorageName, 1);
  }

  openPopup() {
    this.dataset.status = 1;
    this.style.display = "initial";
    setTimeout(() => {
      this.style.opacity = 1;
    }, 300);
  }

  closePopup() {
    this.dataset.status = 0;
    const checkboxDisable = this.querySelector(
      "#country-popup-disable"
    ).checked;

    if (checkboxDisable) {
      this.disablePopup();
    }

    this.style.opacity = 0;
    setTimeout(() => {
      this.style.display = "none";
    }, 300);
  }

  onClickOut() {
    const ignoreClickOnMeElement = this.querySelector(".country-popup");

    if (ignoreClickOnMeElement != null) {
      document.addEventListener("click", (event) => {
        if (this.dataset.status !== "1") return;
        const isClickInsideElement = ignoreClickOnMeElement.contains(
          event.target
        );

        if (!isClickInsideElement) {
          this.closePopup();
        }
      });
    }
  }
  onClickCurrentCountry() {
    const currentCountry = this.querySelector("[data-current-store]");
    if (currentCountry != null) {
      currentCountry.addEventListener("click", (event) => {
        this.closePopup();
        this.disablePopup();
      });
    }
  }
}

customElements.define("country-popup", CountryPopup);

function scrollReviewsToTop() {
  const currentUrlParams =
    window.location.search !== "" && window.location.search;
  const productReview = document.querySelector("product-review");

  if (!currentUrlParams || !productReview) return null;

  const searchParams = new URLSearchParams(currentUrlParams);
  const reviewsParam = searchParams.get("scroll-to-reviews");

  if (reviewsParam != null) {
    autoScrollElementTop(productReview);
  }
}

scrollReviewsToTop();
class AvailableFor extends HTMLElement {
  constructor() {
    super();
    this.availableForItems = this.querySelectorAll("[data-saf-type]");
    this.init();
  }

  init() {
    this.toggleHiddenContent();
  }

  toggleHiddenContent() {
    this.availableForItems.forEach((item) => {
      item.addEventListener("click", () => {
        const { status } = item.dataset;

        if (status === "0") {
          this.showHiddenContent(item);
        }

        if (status === "1") {
          this.hideHiddenContent(item);
        }
      });
    });
  }

  showHiddenContent(element) {
    const hiddenContent = element.querySelector(".this-content-hidden");
    element.classList.add("active");
    hiddenContent.style.display = "block";
    element.setAttribute("data-status", 1);
  }

  hideHiddenContent(element) {
    const hiddenContent = element.querySelector(".this-content-hidden");
    element.classList.remove("active");
    hiddenContent.style.display = "none";
    element.setAttribute("data-status", 0);
  }
}

customElements.define("available-for", AvailableFor);

class CartSection extends HTMLElement {
  constructor() {
    super();
    this.continueShoppingBack();
    this.observerTotal();
  }

  continueShoppingBack() {
    const continueShoppingBtn = this.querySelector(".cart-continue-shopping");
    continueShoppingBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.style.opacity = "0.5";
      history.go(-1);
    });
  }

  /**
   * Hides all th prices if there is no discount
   * @returns void
   */
  thHidePriceIfNoDiscount(element) {
    const salePrice = element.querySelector(".th_cart_total_sale_price");
    const originalPrice = element.querySelector(
      ".th_cart_total_original_price"
    );
    const discountMessage = element.querySelector(
      ".th_cart_fixed_discount_msg"
    );
    const salePriceMoney = salePrice.querySelector(".money");
    const originalPriceMoney = originalPrice.querySelector(".money");

    const allElements = [
      salePrice,
      originalPrice,
      discountMessage,
      salePriceMoney,
      originalPriceMoney,
    ];
    allElements.forEach((el) => el == null && null);

    if (salePriceMoney.innerHTML == originalPriceMoney.innerHTML) {
      originalPrice.classList.add("hide");
      salePrice.style.display = "flex";
      discountMessage.style.display = "none";
    }
  }

  /**
   * Listens for th bundle cart total update then runs thHidePriceIfNoDiscount()
   * @returns void
   */
  observerTotal() {
    const totalPrice = this.querySelector(".th_cart_total_price");
    if (totalPrice == null) return null;

    const mutationCallback = (mutations) => {
      if (mutations[0] == null) return null;
      const { target } = mutations[0];
      this.thHidePriceIfNoDiscount(target);
    };

    const mu = new MutationObserver(mutationCallback);
    mu.observe(totalPrice, { childList: true });
  }
}

customElements.define("cart-section", CartSection);

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.atcb = this.querySelector("[data-sticky-atcb]");
    this.init();
  }

  init() {
    if (this.atcb == null) return null;
    this.atcb.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleAddToCart();
    });

    window.addEventListener(
      "scroll",
      function () {
        throttle(this.changeDesign(), 200);
      }.bind(this)
    );
  }

  handleAddToCart() {
    const firstSection = document.querySelector("body section");
    if (firstSection == null) return null;
    const bundleSection =
      document.querySelector(".snippet-productBundleCarousel") ??
      document.querySelector(".snip-bundle-carousel");

    autoScrollElementTop(bundleSection ?? firstSection);
  }

  changeDesign() {
    const bodyScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    if (bodyScrollTop >= 200) {
      this.style.display = "grid";
    }

    if (bodyScrollTop <= 200) {
      this.style.display = "none";
    }
  }
}
customElements.define("sticky-add-to-cart", StickyAddToCart);

function doProductCard() {
  if (customElements.get("product-card")) return null;
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.productTopFold = document.querySelector(".section-product-top-fold");
      this.image = this.querySelector(".spc-image img");
      this.priceSnippet = this.querySelector(".snippet-price");
      this.variantSelector = this.querySelector(
        `#pcv-${this.dataset.productId}`
      );

      this.init();
    }

    init() {
      this.variantSelector &&
        this.variantSelector.addEventListener("change", (e) => {
          const eventAttr = (attr) =>
            e.target.selectedOptions[0].getAttribute(attr);
          this.changeImage(eventAttr("data-image"));
          this.updatePrice(
            eventAttr("data-price"),
            eventAttr("data-compare-at-price"),
            this.priceSnippet
          );
        });

      this.updateBundlePrices();
    }

    /**
     *
     * @param {String} imageToChange
     */
    changeImage(imageToChange) {
      if (this.image == null) return null;
      this.image.srcset = "";
      this.image.loading = "eager";
      this.image.src = imageToChange;
    }

    updatePrice(price, compareAtPrice, parentPriceElement) {
      if (price == null) return null;
      const comparePrice = compareAtPrice != "" ? compareAtPrice : 0;
      const isOnSale = comparePrice > price;
      if (parentPriceElement == null) return null;
      const priceRegularElement = parentPriceElement.querySelector(
        ".price--regular .price-item--regular"
      );
      const priceSaleOriginalElement = parentPriceElement.querySelector(
        ".price--sale .price-item--regular"
      );
      const priceSaleElement = parentPriceElement.querySelector(
        ".price--sale .price-item--sale"
      );
      if (
        priceRegularElement == null ||
        priceSaleOriginalElement == null ||
        priceSaleElement == null
      ) {
        console.log("updatePrice(): One or all of the variables are null", [
          priceRegularElement,
          priceSaleOriginalElement,
          priceSaleElement,
        ]);
        return null;
      }

      if (isOnSale) {
        priceSaleOriginalElement.innerHTML = this.makePrice(price);
        priceSaleElement.innerHTML = this.makePrice(comparePrice);
        parentPriceElement.classList.add(".price--on-sale");
        return;
      }

      parentPriceElement.classList.remove(".price--on-sale");
      priceRegularElement.innerHTML = this.makePrice(price);
    }

    makePrice(priceString) {
      const priceNumber = parseFloat(priceString);
      const readyPrice = (priceNumber / 100).toFixed(2);
      return `<span class="money">$ ${readyPrice} ${window.Shopify.currency.active}</span>`;
    }

    updateBundlePrices() {
      const isBundle =
        this.productTopFold && this.productTopFold.dataset.isbundle == "true";
      if (isBundle == false) return null;
    }
  }

  customElements.define("product-card", ProductCard);
}
doProductCard();
